import { createStore } from "vuex";

export default createStore({
  state: {
    //   路由信息
    routes: [],
    //   举报须知点击事件
    clickNotice: "",
    //   栏目数据
    channelData: [],
  },
  getters: {
    getRoutes(state) {
      return state.routes;
    },
    getClickNotice(state) {
      return state.clickNotice;
    },
    getChannelData(state) {
      return state.channelData;
    },
  },
  mutations: {
    setRoutes(state, routes) {
      state.routes = routes;
    },
    setClickNotice(state, clickNotice) {
      state.clickNotice = clickNotice;
    },
    setChannelData(state, channelData) {
      state.channelData = channelData;
    },
  },
  actions: {},
  modules: {},
});
